import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { AutenticacaoService } from "./autenticacao.service";

@Injectable({
    providedIn: 'root'
})

export class AutenticacaoGuard {
    
    constructor(
        private servicoAutenticacao: AutenticacaoService,
        private router: Router
    ){}

    async canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        const requiredAccessLevels: number[] = route.data["requiredAccessLevel"] || [];
        const requiredAccessCompany: string[] = route.data["requiredFlow"] || [];
        // const userAccessLevel = await this.servicoAutenticacao.getUserAccessLevel();
        const [userAccessLevel, userFlows] = await this.servicoAutenticacao.getUserAccessLevel();
        // //console.log("userAccessLevel")
        // //console.log(userAccessLevel)
        // //console.log("userFlows")
        // //console.log(userFlows)
        // //console.log("requiredAccessLevels")
        // //console.log(requiredAccessLevels)
        // //console.log("requiredAccessCompany")
        // //console.log(requiredAccessCompany)
        await this.servicoAutenticacao.updateLoggedIn();
        // //console.log("entrou no canActivate")
        if (!this.servicoAutenticacao.isUserLoggedIn()) {
            alert("Efetue o Login")
            this.router.parseUrl('login');
            return false;
        }
        // //console.log(route.data)
        // Verifica o nível de acesso necessário para a rota
        // const requiredAccessLevel = route.data["requiredAccessLevel"];

        // Aqui, você pode ter uma lógica mais avançada para verificar o nível de acesso do usuário
        // Neste exemplo, assume-se que o usuário tem uma propriedade 'accessLevel' no objeto de usuário
        if ((userAccessLevel == 3 && requiredAccessCompany.includes(userFlows)) || (userAccessLevel == 3 && requiredAccessCompany.includes('All'))) {
            return true;
        } else if (userAccessLevel != 3){
            if (requiredAccessLevels.includes(userAccessLevel)) {
                return true;
            } else {
                this.router.navigate(['/unauthorized']); // Redireciona para a página de não autorizado se o nível de acesso for insuficiente
                return false;
            }
        } else {
            this.router.navigate(['/unauthorized']); // Redireciona para a página de não autorizado se o nível de acesso for insuficiente
            return false;
        }
    }           
}